export default __webpack_public_path__ + "4f70f4df7e8b48ae318c01cdd793d014.mp3";